import React, { useEffect } from "react";
import "./i18n/i18n";
import "./styles/main.css";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import AboutSection from "./components/AboutSection";
import YoutubeSection from "./components/YoutubeSection";
import SpotifySection from "./components/SpotifySection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

function App() {
  useEffect(() => {
    const qs = window.location.search;

    let deviceInformations = "unknown";

    try {
      const device = {
        dpr: window.devicePixelRatio || null,
        screen: {
          w: window.screen?.width || null,
          h: window.screen?.height || null,
        },
        touch: navigator.maxTouchPoints || null,
        language: navigator.language || null,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || null,
      };

      try {
        const canvas = document.createElement("canvas");
        const gl = canvas.getContext("webgl");
        const dbg = gl.getExtension("WEBGL_debug_renderer_info");
        if (dbg) {
          device.gpu = gl.getParameter(dbg.UNMASKED_RENDERER_WEBGL);
        }
      } catch {}

      deviceInformations = device;
    } catch {}

    fetch(`/api/visit${qs}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ device_informations: deviceInformations }),
    }).catch(() => {});
  }, []);
  return (
    <div className="App northwind">
      <Navbar />
      <Hero />
      <main>
        <AboutSection />
        <YoutubeSection />
        <SpotifySection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
